import React, {Fragment} from "react";
import {AdditionalSellUnit} from "../../@types/stores/menu";
import {useTranslation} from "react-i18next";
import {getCurrency} from "../../helpers/ApiHelper";
import "./style.scss";
import {ReactComponent as IconCheck} from "../../assets/icons/check.svg";


export interface HalfAndHalfAdditionalSellUnitsProps {
    items: AdditionalSellUnit[];
    selected: AdditionalSellUnit | null;
    onSelect: (item: AdditionalSellUnit | null) => void;
}

const HalfAndHalfAdditionalSellUnits = ({items, selected, onSelect}: HalfAndHalfAdditionalSellUnitsProps) => {
    const [t] = useTranslation();

    const select = (isSelected: boolean, item: AdditionalSellUnit) => {
        onSelect(isSelected ? item : null);
    }

    return <div className="HalfAndHalfAdditionalSellUnits articleGroup">
        <div className={`groupHeader`}>
            <div className="groupTitle">
                <div>
                    <div className="step">{t("halfNHalf.stepTitle.size")}</div>
                </div>
            </div>
        </div>
        <div className="items">
            {items.map(x => <Fragment key={`hahArticle_${x.sellUnitId}_${x.sellFactor}_${x.name}`}>
                <HalfAndHalfAdditionalSellUnitsItem
                    item={x}
                    checked={selected?.sellUnitId === x.sellUnitId && selected?.sellFactor === x.sellFactor}
                    onChange={(selected: boolean) => select(selected, x)}
                />
            </Fragment>
            )}
        </div>
    </div>
}

export interface HalfAndHalfAdditionalSellUnitsItemProps {
    item: AdditionalSellUnit;
    checked: boolean;
    onChange: (selected: boolean) => void;
}

const HalfAndHalfAdditionalSellUnitsItem = ({item, checked, onChange}: HalfAndHalfAdditionalSellUnitsItemProps) => {

    return <div className="HalfAndHalfAdditionalSellUnitsItem articleGroupItem">
        <div key={`menuItem_${item.name}`} className="item" onClick={() => onChange(!checked)}>
            <div className="text">
                <div className="title">
                    {item.name}
                </div>
                <div className="price">
                    {item.price.toFixed(2)} {getCurrency()}
                </div>
                {checked
                    ? <div className="check">
                        <IconCheck />
                    </div>
                    : null
                }
            </div>
        </div>
    </div>
}

export default HalfAndHalfAdditionalSellUnits;
